<template>
    <div id="megamenu" :class="['cms_megamenu_outer_cont', stylename]" :cms_menuname="menuname" v-show="MenuHtml!=''">
        <GrcDB ref="GRCDB"></GrcDB>
        <div class="cms_megamenu_inner_cont" v-html="MenuHtml" />
    </div>
</template>

<script>

import GrcDB from './GrcDB.vue'

export default {
  name: 'grccms_megamenu',
  components: {
    GrcDB,
  },
  props: {
    cms_menuname: String,
    cms_stylename: String
  },

  data () {
        return {
            menuname: this.cms_menuname,
            stylename: this.cms_stylename,
            MenuHtml: "",
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sAlias: GRCAPP_GetParameters.ALIAS,
            sMenuName: this.menuname,
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_GetMegaMenu", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }


        let s = Q.DATA[0].MenuHtml.replace(/>\s+</g,'><');
        this.MenuHtml = s;

    },

  },
  created()
  {
    if (typeof this.menuname == "undefined")
    {
      this.menuname = "";
    }

    if (typeof this.stylename == "undefined")
    {
      this.stylename = "";
    }


    if (this.menuname == "") { return; }
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
